module.exports = __webpack_public_path__ + "img/ssclick-premium-reward.537b29f5.png";